module.exports = __webpack_public_path__ + "img/Monte_Kope_47.1f3b831e.jpg";